import { render, staticRenderFns } from "./HighestSpreadsComponent.vue?vue&type=template&id=706181f6&scoped=true&"
import script from "./HighestSpreadsComponent.vue?vue&type=script&lang=ts&"
export * from "./HighestSpreadsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./HighestSpreadsComponent.vue?vue&type=style&index=0&id=706181f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706181f6",
  null
  
)

export default component.exports